import { ref } from 'vue'

// Global state for 403 permission errors
const isPermissionErrorVisible = ref(false)
const permissionErrorMessage = ref('')

export function usePermissionError() {
  const showPermissionError = (message?: string) => {
    permissionErrorMessage.value = message || 'You don\'t have permission to access this resource. Please contact your administrator or try accessing from the dashboard.'
    isPermissionErrorVisible.value = true
  }

  const hidePermissionError = () => {
    isPermissionErrorVisible.value = false
    permissionErrorMessage.value = ''
  }

  const handlePermissionError = (error: any) => {
    if (error?.response?.status === 403) {
      const message = error.response?.data?.message ||
                     error.response?.data?.error ||
                     'You don\'t have permission to access this resource.'
      showPermissionError(message)
      return true // Indicates error was handled
    }
    return false // Error was not a 403
  }

  return {
    isPermissionErrorVisible,
    permissionErrorMessage,
    showPermissionError,
    hidePermissionError,
    handlePermissionError
  }
}
